var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.941,
    height: 17,
    viewBox: "0 0 14.941 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_1_",
    "data-name": "delete (1)",
    transform: "translate(-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13844",
    "data-name": "Path 13844",
    d: "M31.5,151h1.494v10.525a.5.5,0,0,0,.5.5h9.961a.5.5,0,0,0,.5-.5V151h1.494a.5.5,0,0,0,0-1H31.5a.5.5,0,0,0,0,1Zm4.482,9.031a.5.5,0,0,1-1,0v-8.035a.5.5,0,0,1,1,0Zm2.988,0a.5.5,0,0,1-1,0v-8.035a.5.5,0,0,1,1,0Zm2.988,0a.5.5,0,0,1-1,0v-8.035a.5.5,0,0,1,1,0Z",
    transform: "translate(0 -145.02)",
    fill: "#777"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13845",
    "data-name": "Path 13845",
    d: "M73.949,2.49a.5.5,0,0,0-.5-.5H69.965V.5a.5.5,0,0,0-.5-.5H65.482a.5.5,0,0,0-.5.5V1.992H61.5a.5.5,0,0,0-.5.5V3.984H73.949ZM65.98,1h2.988v1H65.98Z",
    transform: "translate(-29.004)",
    fill: "#777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.359cb286aba110e75b6ff05d5b13cd91.svg";
export { ForwardRef as ReactComponent };